

export const getBnoCategory = (bno) => {
  if (bno >= 'C9200' && bno <= 'C9590') {
    return 'AL'
  }

  if (bno >= 'C9000' && bno <= 'C9020') {
    return 'MM'
  }

  if (bno >= 'C9100' && bno <= 'C9190') {
    return 'CLL'
  }

  if (bno >= 'C8200' && bno <= 'C8890') {
    return 'NHL'
  }

  if (bno >= 'C9600' && bno <= 'C9691') {
    return 'NHL'
  }

  if (bno >= 'C8100' && bno <= 'C8190') {
    return 'HL'
  }
}

export const getValidWhoInnerCodes = (category) => {
  switch (category) {
  case 'AL':
    return ['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10', 'A11', 'A12' ]
  case 'MM':
    return []
  case 'CLL':
    return []
  case 'NHL':
    return ['1.1', '1.2', '1.2.2']
  case 'HL':
    return ['1', '2', '3', '4']
  }
  return []
}

export const getValidMcodes = (category) => {
  switch (category) {
  case 'AL':
    return Array(187).fill().map((_, index) => '' + (index + 1000))
  case 'MM':
    return Array(29).fill().map((_, index) => '' + (index + 1300))
  case 'CLL':
    return Array(14).fill().map((_, index) => '' + (index + 1200))
  case 'NHL':
    return Array(1702 - 1500 + 1).fill().map((_, index) => '' + (index + 1500))
  case 'HL':
    return Array(438).fill().map((_, index) => '' + (index + 1400))
  }
  return []
}
